<template>
  <div class="setting-bar">
     <div v-if="!checkedShow" class="item" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
      <span class="f-l name">{{name}}</span>
      <span v-show="!checkedShow" class="f-r iconfont">&#xe646;</span>
      <cube-checkbox class="f-r checked" v-show="checkedShow" :option="option" v-model="checked" @input="selectItem"></cube-checkbox>
      <span class="f-r sub-name">{{subName}}</span>
    </div>
    <div v-else class="item">
      <span class="f-l name">{{name}}</span>
      <span v-show="!checkedShow" class="f-r iconfont">&#xe646;</span>
      <cube-checkbox class="f-r checked" v-show="checkedShow" :option="option" v-model="checked" @input="selectItem"></cube-checkbox>
      <span class="f-r sub-name">{{subName}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DataBar',
  props: {
    name: String,
    subName: String,
    isChecked: {
      type: Boolean,
      default: false
    },
    checkedShow: {
      type: Boolean,
      default: false
    },
    index: Number,
    isCancel: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      allCancel: this.isCancel,
      checked: this.isChecked,
      option: {
        label: '',
        value: '',
        disabled: false
      },
      longClick: 0,
      timeOutEvent: null
    }
  },
  methods: {
    handleTouchStart () {
        this.longClick = 0 // 设置初始为0
        this.timeOutEvent = setTimeout(() => {
        this.checked = true
        this.allCancel = false
        this.$emit('changeModel', this.index)
        this.longClick = 1 // 假如长按，则设置为1
      }, 500) 
    },
    handleTouchMove (e) {
      clearTimeout(this.timeOutEvent)
      e.preventDefault()
    },
    handleTouchEnd () {
      clearTimeout(this.timeOutEvent)
      if (this.longClick === 0) { // 点击
        // 点击修改提醒事件
        // this.$emit('timeClick', this.subName)
      }
      return false
    },
    selectItem () {
      this.$emit('changeSelect', {'checked': this.checked, 'index': this.index})
    }
  },
  watch: {
    isCancel (newValue) {
      this.allCancel = newValue
      if (newValue) this.checked = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.item
  height 47px
  line-height 47px
  color #333333
  background #ffffff
  padding-left 15px
  font-size 16px
  border-radius 5px
  .iconfont
    padding 0 15px
  .sub-name
    color #666666
  .checked
    margin-top 2.5px
</style>


// WEBPACK FOOTER //
// src/pages/TakePillsSetting/compoments/DataBar.vue